import { Alert, Button, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import show from "../../api/auth/waivers/reservationWaivers/show";
import PageLoading from "../../components/layout/PageLoading";
import WushCard from "../../components/layout/WushCard";
import sign from "../../api/auth/waivers/reservationWaivers/sign";
import WushTextField from "../../components/form/WushTextField";
import SignatureField from "../../components/form/SignatureField";
import useAlertStore from "../../stores/useAlertStore";

export default function ReservationWaiver() {
  const [ waiver, setWaiver ] = useState(null);

  const { waiverUuid, reservationWaiverId } = useParams();

  const sigRef = useRef(null);

  const { register, handleSubmit, setValue, formState: { errors } } = useForm();

  const { setAlertMessage } = useAlertStore();

  useEffect(() => {
    show(waiverUuid, reservationWaiverId, (response) => {
      console.log(response);
      setWaiver(response);
    });
  }, []);

  const onSubmit = (data) => {
    sign(waiverUuid, reservationWaiverId, data.signatureFile[0], data.signedByEmail, data.signedByName, (response) => {
      console.log(response);
      setWaiver(response);
      setAlertMessage('Thank you for signing the waiver!', 'success');
    });
  };

  const convertDataUriToFile = (dataUri) => {
    let byteString;
    if (dataUri.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataUri.split(',')[1]);
    else byteString = unescape(dataUri.split(',')[1]);

    // separate out the mime component
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    // eslint-disable-next-line
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    setValue('signatureFile[0]', new Blob([ia], { type: mimeString }));
  };

  if(!waiver) return <PageLoading />;

  console.log(waiver.signed_at);

  return (
    <Stack px={{ xs: 1, sm: "15%"}} py={{ xs: 2, sm: 4}}>
      <WushCard>
        <Stack p={2}>
          {waiver.signed_by_image_url && <Stack mb={2}>
            <Alert severity="info">Signed by {waiver.signed_by_name} on {waiver.signed_at && format(new Date(waiver.signed_at), 'yyyy-MM-dd')}</Alert>
          </Stack>}
          <Stack>
            <Typography variant="h4">{waiver.waiver_name}</Typography>
          </Stack>
          <div dangerouslySetInnerHTML={{__html: waiver.waiver_content}} />
          {waiver.signed_by_image_url ?
          <Stack borderRadius="20px" borderLeft="1px solid black" p={1}>
            <Stack>
              <Typography variant="caption">Signed by {waiver.signed_by_name}</Typography>
            </Stack>
            <Stack mb={1}>
              <img width="25%" src={waiver.signed_by_image_url} alt="signature" />
            </Stack>
            <Stack>
              <Typography variant="caption">{waiver.signed_at && format(new Date(waiver.signed_at), 'yyyy-MM-dd h:mm:ss a')}</Typography>
            </Stack>
          </Stack>
          :
          <Stack>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack mb={2}>
                <WushTextField formRegistration={register("signedByName")} label="Name" formState={{ errors }} />
              </Stack>
              <Stack mb={2}>
                <WushTextField formRegistration={register("signedByEmail")} label="Email" formState={{ errors }} />
              </Stack>
              <Stack
                borderRadius="10px"
                border="1px dashed #000"
                mb={2}
              >
                <SignatureField
                  onEnd={() => convertDataUriToFile(sigRef.current.toDataURL())}
                  sigRef={sigRef}
                />
              </Stack>
              <Stack direction="row">
                <Button variant="contained" type="submit">Sign</Button>
              </Stack>
            </form>
          </Stack>}
        </Stack>
      </WushCard>
    </Stack>
  );
}